import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ThreeDModelsPage } from 'pages/threeDModels/ThreeDModelsPage'
import { DEFAULT_DOCUMENT_TITLE } from 'utils/documentTitle'

import { walkthroughSearchParams } from './-searchParams'

const RouteComponent = () => {
  const { siteId, orgId, asset, view } = Route.useSearch()

  if (!siteId) {
    return <Outlet />
  }

  return (
    <ThreeDModelsPage
      siteId={siteId}
      orgId={orgId}
      selectedAssetKey={asset}
      requestedKind={view}
    />
  )
}

export const Route = createFileRoute('/walkthrough/')({
  component: RouteComponent,
  validateSearch: walkthroughSearchParams,
  staticData: {
    title: `${DEFAULT_DOCUMENT_TITLE} 3D Models`,
  },
})
